<span class="subheader" mat-dialog-title>{{title}}</span>
<mat-dialog-content>{{message}}</mat-dialog-content>
<mat-dialog-actions class="mb-m">
  <button mat-button color="neutral" class="ml-m" (click)="onNoClick()">Nein</button>
  <button mat-flat-button color="primary" (click)="onYesClick()">Ja</button>
</mat-dialog-actions>
